import { isCmoeEnabled } from "./cmoeFeatureFlags";

/** @typedef {'legacy' | 'dual' | 'primary'} CmoeOrchestrationMode */

/**
 * Room session orchestration mode (Phase 3 cutover). Default: legacy.
 * @returns {CmoeOrchestrationMode}
 */
export function getCmoeOrchestrationMode() {
  if (!isCmoeEnabled()) return "legacy";
  const raw = String(process.env.REACT_APP_CMOE_ORCHESTRATION_MODE || "legacy")
    .trim()
    .toLowerCase();
  if (raw === "dual" || raw === "primary") return raw;
  return "legacy";
}

export function isCmoeLegacyOrchestration() {
  return getCmoeOrchestrationMode() === "legacy";
}

export function isCmoeDualOrchestration() {
  return getCmoeOrchestrationMode() === "dual";
}

export function isCmoePrimaryOrchestration() {
  return getCmoeOrchestrationMode() === "primary";
}

/** Reads for match hub / governance from CMOE when primary + projections path available. */
export function shouldReadRoomMatchesFromCmoe() {
  return isCmoePrimaryOrchestration();
}

/**
 * Court runtime reads/writes `activities/{roomMatchId}` instead of `liveMatches` (Phase 4).
 * Legacy single-match sessions (no roomMatchId) keep liveMatches/{roomCode}.
 */
export function isActivityRuntimePrimary(roomMatchId) {
  const id = roomMatchId ? String(roomMatchId).trim() : "";
  return isCmoePrimaryOrchestration() && Boolean(id);
}
